import { Box, useTheme } from '@mui/material';
import React from 'react';
import SideBars from './SideBars';
import OutputBox from './OutputBox';
import InputBox from './InputBox';

const Whapi = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: '70vh',
        minHeight: '700px',
        minWidth: '900px',
        width: '100%',
        maxWidth: '1000px',
        boxShadow: '5px 5px 20px 5px rgba(0,0,0,0.1)',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        bgcolor: theme.palette.mode === 'light' ? 'var(--white)' : 'var(--white01)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
          maxHeight: '80%',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <h3 style={{ fontSize: 14, padding: '10px 20px', width: '100%', backgroundColor: theme.palette.mode === 'light' ? 'var(--black01)' : 'var(--white01)' }}>History Logs</h3>
          <OutputBox />
        </Box>
        <SideBars />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          maxHeight: '20%',
          height: '100%',
          width: '100%',
          overflow: 'hidden',
          padding: '10px',
        }}
      >
        <InputBox />
      </Box>
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          padding: 10,
          fontSize: 10,
          color: 'gray',
        }}
      >
        AE WHAPI v1.0.1
      </div>
    </Box>
  );
};

export default Whapi;
